export default () => {
  $('.u-modal--close').on('click', function (evt) {
    evt.preventDefault();
    $('.u-modal-container').removeClass('is-active');
    $('.u-overlay').removeClass('is-active');
  });
}



// WEBPACK FOOTER //
// ./themes/app/assets/js/modules/modal.js